import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';
// import { Flex, Box } from 'reflexbox';

import { Actions } from '../../Store';
import { regioDataSelector, startYearSelector } from '../../Selectors';
import { getStateName } from '../../config';

import BarChart from './BarChart';

class ResultRegio extends PureComponent {
  componentDidMount() {
    this.props.loadRegioData();
  }

  onRegioSelect(evt) {
    this.props.setRegioId(evt.target.value);
  }

  renderRegioChooser() {
    const { dataRegio, regioId } = this.props;

    const options = Object.keys(dataRegio)
      .map(key => ({ key, name: getStateName(key) }))
      .sort((a, b) => a.name.localeCompare(b.name));

    return (
      <select value={regioId} onChange={(evt) => this.onRegioSelect(evt)}>
        {options.map(o => (
          <option value={o.key} key={o.key}>{o.name}</option>
        ))}
      </select>
    );
  }

  render() {
    const { data, dataRegio, startYear, isBeforeElection } = this.props;

    if (!dataRegio) {
      return 'keine Daten vorhanden.';
    }

    if (startYear === 2019 && isBeforeElection) {
      return null;
    }

    return (
      <div className="result-regio">
        <div className="result-regio-choose">
          <div className="result-headline">Regionales Wahlergebnis</div>
          <div className="result-subline">nach deutschen Bundesländern</div>
          <div className="result-chooser">
            {this.renderRegioChooser()}
          </div>
        </div>
        <div className="result-regio-data">
        {data ? <BarChart data={data} /> : <div className="result-regio-nodata">Kein Wahlergebnis: In Ostdeutschland und Berlin wurde das Europäische Parlament erstmals 1994 gewählt. Aus West-Berlin wurden bis 1989 immer drei Parlamentarier durch das Berliner Abgeordnetenhaus entsandt.</div>}
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  data: regioDataSelector(state),
  dataRegio: state.dataRegio,
  regioId: state.regioId,
  startYear: startYearSelector(state),
  isBeforeElection: state.isBeforeElection
}), Actions)(ResultRegio);
